import angular from 'angular';
class Services {
    /**
     * Services Interface
     * @memberof pims
     * @ngdoc service
     * @param {service} $http xhr library
     * @param {string} API_URL our base api uri
     */
    constructor($http, API_URL, $rootScope, localStorageService, Endpoints) {
      'ngInject';

      Object.assign(this, {
        $http,
        API_URL,
        $rootScope,
        localStorageService,
        Endpoints
      });
    }
    /*
     * List all services
     */


    list() {
      return this.$http.get(this.Endpoints.categories.base + `?limit=100`, {
        loadingText: 'Loading Services'
      });
    }

    fetch(code) {
      return this.$http.get(`${this.API_URL}/admin/categories/${code}`, {
        loadingText: 'Loading Services'
      });
    }

    update(serviceId, updates) {
      return this.$http.put(`${this.API_URL}/admin/categories/${serviceId}`, updates);
    }
    /*
     * Get product details
     */


    getProductDetail(id) {
      return this.$http.get(`${this.API_URL}/products/${id}`, {
        cache: true
      });
    }
    /*
     * Get pharmacy options by category
     */


    getPharmacyOptionsByCategory(id) {
      return this.$http.get(this.Endpoints.categories.pharmacyOptions.replace(":id", id), {
        cache: true
      });
    }
    /*
     * Get products by category
     */


    getProductByCategory(id) {
      // return this.$http.get(this.Endpoints.products.byService.replace(":category_code",id), { cache: true });
      return this.$http.get(`${this.API_URL}/products?category=${id}`, {
        cache: true
      });
    }
    /*
     * Get products by category (new version => shows "product code")
     */


    getProductListByCategory(category_code) {
      return this.$http.get(this.Endpoints.products.listByService.replace(":category_code", category_code), {
        loadingText: 'Loading Products'
      });
    }
    /*
     * Get medications by category
     */


    getMedicationListByCategory(category_code) {
      return this.$http.get(this.Endpoints.medications.listByService.replace(":category_code", category_code), {
        loadingText: 'Loading Medications'
      });
    }
    /*
     * Get list of treatment plan codes
     */


    getTreatmentPlanList(phase) {
      let query = "";
      if (phase) query = "?phase=" + phase;
      return this.$http.get(this.Endpoints.treatmentPlan.codes + query, {
        loadingText: 'Loading Treatment Plans'
      });
    }
    /*
     * Get Content for PIMS
     */


    getPimsParameters() {
      // return this.$http.get(`${this.API_URL}/content/web/pimsParameters?polling=true`);
      return this.$http.get(this.Endpoints.content.pimsParameters + '?polling=true');
    }
    /*
     * Get PIMS content parameters from cache if they exist
     * Otherwise we refresh PIMS content parameters from backend
     */


    getCachedPimsParameters(refresh = false) {
      return new Promise((resolve, reject) => {
        if (refresh) {
          this.getPimsParameters().then(({
            data
          }) => {
            this.localStorageService.set('pimsParameters', data);
            resolve(data);
          }).catch(({
            error
          }) => {
            this.localStorageService.set('pimsParameters', '');
            resolve('');
          });
        } else {
          var pimsParameters = this.localStorageService.get('pimsParameters');

          if (pimsParameters) {
            resolve(pimsParameters);
          } else {
            this.getPimsParameters().then(({
              data
            }) => {
              this.localStorageService.set('pimsParameters', data);
              resolve(data);
            }).catch(({
              error
            }) => {
              this.localStorageService.set('pimsParameters', '');
              resolve('');
            });
          }
        }
      });
    }
    /*
     * Get area codes
     */


    getAreaCodes() {
      return this.$http.get(`${this.API_URL}/areacodes?polling=true`);
    }
    /*
     * Get area codes from cache if they exist
     * Otherwise we refresh cache area codes from backend
     */


    getCacheAreaCodes(refresh = false) {
      return new Promise((resolve, reject) => {
        if (refresh) {
          this.getAreaCodes().then(({
            data
          }) => {
            this.localStorageService.set('areaCodes', data);
            resolve(data);
          }).catch(({
            error
          }) => {
            this.localStorageService.set('areaCodes', []);
            resolve([]);
          });
        } else {
          var areaCodes = this.localStorageService.get('areaCodes');

          if (!areaCodes) {
            areaCodes = [];
          }

          if (areaCodes.length) {
            resolve(areaCodes);
          } else {
            this.getAreaCodes().then(({
              data
            }) => {
              this.localStorageService.set('areaCodes', data);
              resolve(data);
            }).catch(({
              error
            }) => {
              this.localStorageService.set('areaCodes', []);
              resolve([]);
            });
          }
        }
      });
    }

    dialPhoneNumberDisplay(num, format) {
      if (!num || !num.trim()) {
        return num;
      }

      num = num.trim().replace(/(\.|-|\s|\(|\))/g, '');
      const areaCode = num.substring(0, 3);
      const primary = num.substring(3, 6);
      const secondary = num.substring(6, 10);

      if (num.length !== 10) {
        return num;
      }

      switch (format) {
        case '(xxx) xxx-xxxx':
          return `(${areaCode}) ${primary}-${secondary}`;

        case 'xxx xxx-xxxx':
          return `${areaCode} ${primary}-${secondary}`;

        case 'xxx-xxx-xxxx':
          return `${areaCode}-${primary}-${secondary}`;

        default:
          return `(${areaCode})-${primary}-${secondary}`;
      }
    }
    /*
     * Filter phone number (to be called from phone number filter)
     */


    filterPhoneNumber(num, format) {
      return num; // COMMENTED FOR BOOTS
      // THERE ARE NO PHONE FORMATS & AREA CODES FOR UK
      // var areaCodes = this.localStorageService.get('areaCodes');
      // if (!areaCodes) areaCodes = [];
      // if (!num || !num.trim()) {
      //   return num;
      // }
      // num = num.trim().replace(/(\.|-|\s|\(|\))/g, '');
      // const areaCode = num.substring(0, 3);
      // const primary = num.substring(3, 6);
      // const secondary = num.substring(6, 10);
      // if (num.length !== 10) {
      //   return `Invalid Number: ${num}`;
      // }
      // var found = $.grep(areaCodes, function(e){ return e.id == areaCode; });
      // if (found.length == 0) {
      //   return `Invalid Area Code: ${num}`;
      // } else {
      //   switch (format) {
      //     case '(xxx) xxx-xxxx':
      //       return `(${areaCode})-${primary}-${secondary}`;
      //     case 'xxx xxx-xxxx':
      //       return `(${areaCode})-${primary}-${secondary}`;
      //     case 'xxx-xxx-xxxx':
      //       return `(${areaCode})-${primary}-${secondary}`;
      //     default:
      //       return `(${areaCode})-${primary}-${secondary}`;
      //   }
      // }
    }
    /*
    if (currentAge < 18) {
       addAlert();
     } else {
       switch (order.service.code) {
        case 'CP':
          if ((currentAge > 33 || currentAge == 33 && monthsUntilBirthday <= 3) && currentAge < 50) {
            addAlertYellow();
          }
          if (currentAge >= 50) {
            addAlert();
          }
          break;
        case 'UTI':
          if (currentAge >= 65) {
            addAlert();
          }
          break;
        case 'ED':
        case 'EDX':
        case 'EDA':
        case 'PE':
          if (currentAge >= 73 || currentAge < 30) {
            addAlert();
          } else if (currentAge >= 67 && currentAge < 73) {
            addAlertYellow();
          }
          break;
        case 'FLU':
          if (currentAge >= 75) {
            addAlert();
          }
          break;
      }
    }
    */


    validAgeAlert(limits, currentAge, monthsUntilBirthday) {
      var condition1 = true;
      var condition2 = true;
      var limit1_exists = false;
      var limit2_exists = false;

      if (limits.min_year_inclusive_max_months && limits.min_year_inclusive) {
        limit1_exists = true; // (currentAge > 33 || currentAge == 33 && monthsUntilBirthday <= 3)

        if (currentAge > parseInt(limits.min_year_inclusive) || currentAge == parseInt(limits.min_year_inclusive) && monthsUntilBirthday <= parseInt(limits.min_year_inclusive_max_months)) {
          condition1 = false;
        }
      } else if (limits.min_year_inclusive) {
        limit1_exists = true; // (currentAge >= 33)

        if (currentAge >= parseInt(limits.min_year_inclusive)) {
          condition1 = false;
        }
      } else if (limits.min_year_exclusive) {
        limit1_exists = true; // (currentAge > 33)

        if (currentAge > parseInt(limits.min_year_exclusive)) {
          condition1 = false;
        }
      }

      if (limits.max_year_inclusive) {
        limit2_exists = true; // (currentAge <= 76)

        if (currentAge <= parseInt(limits.max_year_inclusive)) {
          condition2 = false;
        }
      } else if (limits.max_year_exclusive) {
        limit2_exists = true; // (currentAge < 76)

        if (currentAge < parseInt(limits.max_year_exclusive)) {
          condition2 = false;
        }
      }

      if (limit1_exists && !limit2_exists) {
        return condition1; // ===> CONDITION FALSE WILL FAIL THE AGE VALIDATION
      } else if (!limit1_exists && limit2_exists) {
        return condition2; // ===> CONDITION FALSE WILL FAIL THE AGE VALIDATION
      } else if (limit1_exists && limit2_exists) {
        var min_value = limits.min_year_inclusive ? parseInt(limits.min_year_inclusive) : parseInt(limits.min_year_exclusive);
        var max_value = limits.max_year_inclusive ? parseInt(limits.max_year_inclusive) : parseInt(limits.max_year_exclusive);

        if (min_value <= max_value) {
          // EXAMPLES:
          // (currentAge >= 33 && currentAge < 76)
          // (currentAge > 33 && currentAge <= 76)
          return condition1 || condition2; // ===> HITTING BOTH CONDITIONS (2 FALSE) WILL FAIL THE AGE VALIDATION
        } else {
          // EXAMPLES:
          // (currentAge >= 73 || currentAge < 30)
          // (currentAge > 73 || currentAge <= 30)
          return condition1 && condition2; // ===> HITTING ONE CONDITION (1 FALSE) WILL FAIL THE AGE VALIDATION
        }
      }

      return true;
    }
}

Services.$inject = ["$http", "API_URL", "$rootScope", "localStorageService", "Endpoints"];
angular.module('pims').service('Services', Services);
